import { useEffect } from 'react';
import { formatInboxBadgeCount } from '../inboxBadgeCount';
import { useInboxSummary } from './useInboxSummary';

/** The static `<title>` from `index.html`; no page sets its own title. */
export const BASE_DOCUMENT_TITLE = 'CodeMerlin';

export function inboxDocumentTitle(newCount: number): string {
  return newCount > 0
    ? `(${formatInboxBadgeCount(newCount)}) ${BASE_DOCUMENT_TITLE}`
    : BASE_DOCUMENT_TITLE;
}

/**
 * Prefixes the browser tab title with the inbox new-item count — `(3) CodeMerlin` — so a
 * background tab shows that something arrived. Reads the same summary query as the sidebar
 * badge (one shared request, same 60s poll), so the two always agree, and restores the plain
 * title on unmount (leaving the dashboard shell, logging out).
 *
 * Call once, from `DashboardLayout`; `SidebarNav` renders twice (rail and mobile drawer).
 */
export function useInboxDocumentTitle(organizationId: string | undefined): void {
  const { data } = useInboxSummary(organizationId);
  const newCount = data?.new_count ?? 0;

  useEffect(() => {
    document.title = inboxDocumentTitle(newCount);
  }, [newCount]);

  useEffect(
    () => () => {
      document.title = BASE_DOCUMENT_TITLE;
    },
    []
  );
}
